// --------------------------------------------------------
// CardInformationUser - CardInformationUser
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React from "react";
import { useSelector } from "react-redux";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import PhotoUser from "../photoUser/PhotoUser";
import {Text } from "../UI/generalLayout/Layout.styled";
import {
  ContainerCardUser,
  InformationCardUser,
  TitleName,
  TitleWelcome,
} from "./CardInformationUser.styled";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CardInformationUser INTERFACE
// --------------------------------------------------------

interface ICardInformationUser {
  isFetchingPhoto: boolean;
  setIsFetchingPhoto: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CardInformationUser = ({ isFetchingPhoto, setIsFetchingPhoto }: ICardInformationUser) => {
  // --------------------------------------------------------
  // CardInformationUser PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { userInfo } = useSelector((state: any) => state.login);
  const { isDesktop, isTablet } = useResponsiveInfo();
  // --------------------------------------------------------

  

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <ContainerCardUser>
      <PhotoUser isFetchingPhoto={isFetchingPhoto} setIsFetchingPhoto={setIsFetchingPhoto} />
      <InformationCardUser>
        <TitleWelcome>Bem vindo ao Saúde Plena!</TitleWelcome>
        <TitleName>{userInfo.nome}</TitleName>
      </InformationCardUser>
    </ContainerCardUser>
  );
  // --------------------------------------------------------
};

export default CardInformationUser;
